export default "__VITE_ASSET__Bv8kjASX__"